// extracted by mini-css-extract-plugin
module.exports = {"skeletonInfoPanel":"SkeletonInfoPanel_skeletonInfoPanel__1JV4H"};